import { memo } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { fontSizeOptionsForThickness } from '../../../../utils/helpers';

const PatientBorder = ({
  patientBorders,
  setPatientBorders,
  updatePatingBorders,
}) => {
  const { top, right, left, bottom, color, thickness } = patientBorders;
  const handlePatientBorder = (itemName, val) => {
    setPatientBorders({
      ...patientBorders,
      [itemName]: val,
    });
  };

  return (
    <Row className="item-container align-items-center ml-0 mt-3">
      <Col md={2}>Patient Section Border:</Col>
      <Col md={1}>
        <Form.Check
          type="checkbox"
          label="Top"
          checked={top}
          onChange={(e) => handlePatientBorder('top', e.target.checked)}
        />
      </Col>
      <Col md={1}>
        <Form.Check
          type="checkbox"
          label="Right"
          checked={right}
          onChange={(e) => handlePatientBorder('right', e.target.checked)}
        />
      </Col>
      <Col md={1}>
        <Form.Check
          type="checkbox"
          label="Bottom"
          checked={bottom}
          onChange={(e) => handlePatientBorder('bottom', e.target.checked)}
        />
      </Col>
      <Col md={1}>
        <Form.Check
          type="checkbox"
          label="Left"
          checked={left}
          onChange={(e) => handlePatientBorder('left', e.target.checked)}
        />
      </Col>
      <Col md={1}>
        <Form.Control
          size="sm"
          type="color"
          placeholder="color"
          value={color || ''}
          onChange={(e) => handlePatientBorder('color', e.target.value)}
        />
      </Col>
      <Col md={1}>
        <Form.Select
          className="form-control form-control-sm"
          value={thickness}
          defaultValue={thickness}
          onChange={(e) => handlePatientBorder('thickness', e.target.value)}
        >
          <option key={''} value=''>Select One</option>
          {fontSizeOptionsForThickness?.slice(0, 8).map((element, index) => (
            <option key={index}>{element}</option>
          ))}
        </Form.Select>
      </Col>
      <Col md={1} className="text-center">
        <Button variant="primary" size="sm" onClick={updatePatingBorders}>
          Submit
        </Button>
      </Col>
    </Row>
  );
};

export default memo(PatientBorder);
